import * as React from 'react';
export var Group = function (_a) {
    var children = _a.children;
    return (React.createElement("ul", { className: "m-0 flex p-0 justify-end" }, React.Children.map(children, function (child) { return (React.createElement("li", { className: "flex p-0 mx-1" }, child)); })));
};
